module.exports = __webpack_public_path__ + "img/login-text-bg.46ebe543.svg";